import { render, staticRenderFns } from "./tax-certificate-list.vue?vue&type=template&id=66095e97&scoped=true&"
import script from "./tax-certificate-list.vue?vue&type=script&lang=ts&"
export * from "./tax-certificate-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66095e97",
  null
  
)

export default component.exports